module.exports = __webpack_public_path__ + "static/media/icon-visible.db0111cf.svg";